var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M21,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H3c-1.1,0-2-0.9-2-2l0,0L1,6c0-1.1,0.9-2,2-2l0,0H21z  M6.1,8.6C5.5,8.6,4.9,8.7,4.4,9s-0.9,0.7-1.2,1.2s-0.4,1.1-0.4,1.7s0.1,1.2,0.4,1.7s0.7,0.9,1.2,1.2s1.1,0.4,1.7,0.4 c0.6,0,1.2-0.1,1.7-0.4s0.9-0.7,1.2-1.2c0.3-0.5,0.4-1.1,0.4-1.7s-0.1-1.2-0.4-1.7C8.8,9.7,8.4,9.3,7.8,9S6.8,8.6,6.1,8.6z  M12.4,8.7h-2.3V15h2.2c1.1,0,1.9-0.3,2.5-0.8c0.6-0.5,0.9-1.3,0.9-2.4c0-0.6-0.1-1.2-0.4-1.7c-0.3-0.5-0.7-0.8-1.2-1.1 C13.7,8.8,13.1,8.7,12.4,8.7z M21.3,8.7h-5.1V10h1.8V15h1.6V10h1.8V8.7z M12.5,10c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.8,0.4,1.3 c0,0.6-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.5-1.3,0.5h-0.8V10H12.5z M6.1,10.1c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.4,0.6,0.6 s0.2,0.6,0.2,0.9c0,0.4-0.1,0.7-0.2,0.9c-0.2,0.3-0.4,0.5-0.6,0.6s-0.6,0.2-0.9,0.2c-0.3,0-0.6-0.1-0.9-0.2s-0.5-0.4-0.6-0.6 c-0.2-0.3-0.2-0.6-0.2-0.9c0-0.4,0.1-0.7,0.2-0.9c0.2-0.3,0.4-0.5,0.6-0.6C5.5,10.2,5.8,10.1,6.1,10.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOdt);
export default __webpack_public_path__ + "static/media/ic_ODT.b0f55b28.svg";
export { ForwardRef as ReactComponent };